import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";

import { max, mergeMap } from "rxjs/operators";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig, Validator } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { ElementdetailsService } from "src/app/Service/elementdetails/elementdetails.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { IDocSetModel, IScheduleDefinitionModel, IStageElementDetails, IPorjectInputModel, IScheduleDefUploadStatusModel } from "src/app/ViewModel/ScheduleDefinitionModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleDefinitionExcelUploadComponent } from '../schedule-definition-excel-upload/schedule-definition-excel-upload.component';
import { ElementDetailsCacheService, Module } from "src/app/Service/element-details.data.service";
import { ProjectViewModel } from "src/app/ViewModel/ProjectModel";
import { DocSetReviseComponent } from "../docset-revise/docset-revise.component";
import { EncryptDecryptService } from "src/app/Service/encrypt-decrypt.service";
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { DataBindingDirective, GridDataResult, PageChangeEvent } from "@progress/kendo-angular-grid";



@Component({
    selector: 'app-schedule-defintion',
    templateUrl: './schedule-definition.component.html',
    styleUrls: ['./schedule-definition.component.css']
})
export class ScheduleDefintionComponent implements OnInit, OnDestroy {
    enableFilter = false;
    isStageConfigLoaded: boolean = false;
    isAllowEdit: boolean = false;
    @ViewChild('schDefForm',{static:true}) schDefFormComponent!: DynamicFormComponent;
    @ViewChild('docSetForm') docSetFormComponent!: DynamicFormComponent;
    @ViewChild(DataBindingDirective) directive: any;
    schDefList: IScheduleDefinitionModel[] = [];
    docSetList: IDocSetModel[] = [];
    stageConfig: any[] = [];
    docSetStageConfig: FieldConfig[] = [];
    schConfig: FieldConfig[] = [];
    docConfig: FieldConfig[] = [];
    structPackEleId!: number;
    discEleId!: number;
    selectedOption: string = 'schedule';
    isSchDefEdit: boolean = false;
    projectId!: number;
    groupId!: number;
    memberId!: number;
    projectCode!: string;
    currentEditDocSet: IDocSetModel | null = null;
    isFetchDateFromDS: boolean = false;
    projModel: ProjectViewModel | null = null;
    @ViewChild('excelDocSetUpload') excelDocSetUpload: any;
    @ViewChild('excelSchDefUpload') excelSchDefUpload: any;
    acceptFileTypes: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    UnsubscribeArray: Subscription[] = [];
    filter: any = null;

    constructor(public _datepipe: DatePipe, private _scheDefService: ScheduleDefinitionService, private _projInfoService: ProjectInfoService, private loaderService: LoaderService,
        private _eleDetailsService: ElementdetailsService, private _notificationService: NotificationService, private _commonService: CommonService, private dialog: MatDialog, private _elementDetailCache: ElementDetailsCacheService,
        private _dialog: MatDialog, private encryptDecryptService: EncryptDecryptService) {

    }

    ngOnInit() {
        this.projectId = this._commonService.getProjectId();
        this.projectCode = this._commonService.getProjectCode();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.memberId = this._commonService.getLoggedInUserId();
        let structureId = this._projInfoService.getProjectElementIdByDescription('Structure / Package').subscribe((x:any) => {
            this.structPackEleId = x.deId;
        });
        this.UnsubscribeArray.push(structureId);
        let disciplineId = this._projInfoService.getProjectElementIdByDescription('Discipline').subscribe((x:any) => {
            this.discEleId = x.deId;
        });
        this.UnsubscribeArray.push(disciplineId);
        this.projModel = this._commonService.getCurrentProjectDetails();
        this.loadDynamicForm(true);
        this.loadScheduleDefintionList();
        this.enableMemberRoleFeatures();

        if (this._commonService.hasRequestedObject()) {
            var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this._commonService.getSessionStorageItem('requestedObject')));
            this.changeButtonToggle({ source: null, value: 'docset' });
        }
    }

    loadDynamicForm(isSchDef: boolean) {
        if (!this.isStageConfigLoaded) {
            let dynamicForm = this._projInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Workflow, deDescription: 'Workflow Status' }).subscribe((res: IProjectElementDetailsOutput[]) => {
                this.stageConfig = res.map(x => {
                    let field: FieldConfig = {
                        type: 'eipdaterange', de_id: x.dedId,
                        name: x.dedShortDescription, label: x.dedDescription + " (" + x.dedShortDescription + ")",
                        rangeControlNames: [x.dedShortDescription + 'StartDate', x.dedShortDescription + 'EndDate'],
                        value: new BehaviorSubject([]),
                        minDate: this.projModel ? this.projModel.startDate : null,
                        maxDate: this.projModel ? this.projModel.endDate : null,
                        startDate: null,
                        endDate: null
                    }
                    return field;
                })
                this.docSetStageConfig = res.map(x => {
                    let field: FieldConfig = {
                        type: 'eipdaterange', de_id: x.dedId,
                        name: x.dedShortDescription, label: x.dedDescription + " (" + x.dedShortDescription + ")",
                        rangeControlNames: [x.dedShortDescription + 'StartDate', x.dedShortDescription + 'EndDate'],
                        value: new BehaviorSubject([]),
                        startDate: null,
                        endDate: null,
                        Var: true
                    }
                    return field;
                })
                this.isStageConfigLoaded = true;
                if (isSchDef)
                    this.buildScheduleDefinitionForm();
                else
                    this.buildDocumentSetForm()
            });
            this.UnsubscribeArray.push(dynamicForm);
        }
        else {
            if (isSchDef)
                this.buildScheduleDefinitionForm();
            else
                this.buildDocumentSetForm()
        }
    }

    get isScheduleDef(): boolean {
        return this.selectedOption === 'schedule';
    };

    buildScheduleDefinitionForm() {
        let cloneStageConfig: FieldConfig[] = this.stageConfig.map(x => { return { ...x } });
        this.schConfig = this.getSchConfig().concat(cloneStageConfig);
        this.schConfig.push({
            type: 'input',
            name: 'noOfDocsRequired',
            label: 'No of Documents Required',
            validations: [
                {
                    name: "required",
                    validator: Validators.required,
                    message: "Please enter number of documents required"
                },
                {
                    name: "pattern",
                    validator: Validators.pattern("^[0-9]*$"),
                    message: "Enter only numbers"
                }
            ]
        });
        this.schDefFormComponent.fields = this.schConfig;
        this.schDefFormComponent.createControl();
    }

    buildDocumentSetForm() {
        let clonedocsetStageConfig: FieldConfig[] = this.docSetStageConfig.map(x => { return { ...x } });
        this.docConfig = this.getDocSetConfig().concat(clonedocsetStageConfig);
        this.docConfig.push({
            type: 'input',
            name: 'noOfDocsRequired',
            label: 'No of Documents Required',
            validations: [
                {
                    name: "required",
                    validator: Validators.required,
                    message: "Please enter number of documents required"
                },
                {
                    name: "pattern",
                    validator: Validators.pattern("^[0-9]*$"),
                    message: "Enter only numbers"
                },
                {
                    name: "min",
                    validator: Validators.min(1),
                    message: "Minimum No Of Docs Required:1"
                }
            ]
        });
        this.docSetFormComponent.fields = [];
        this.docSetFormComponent.fields = this.docConfig;
        this.docSetFormComponent.createControl();
        this.clearDocsetdate();
        let setformbulkdoc:any = this.docSetFormComponent.form.get('Structure/Package Name')?.valueChanges.subscribe((x: IProjectElementDetailsOutput) => {
            if (!!x) {
                let schDefModel: any = this.schDefList.find(y => y.deD_Id == x.dedId);
                this.docSetStageConfig.forEach(x => {
                   
                    
                    let docSetStageDetail: IStageElementDetails | undefined;
                    if (this.isFetchDateFromDS && !!this.currentEditDocSet) {
                        docSetStageDetail = this.getDocSetStageDetail(this.currentEditDocSet, x);
                    }
                    let stageDetail: any = this.getStageDetail(schDefModel, x);
                    if (stageDetail) {
                        let _x = this.docConfig.find(x => x.de_id == stageDetail.stage_Id)
                        if (_x) {
                            let field: FieldConfig = _x
                            field.minDate = stageDetail.start_Date;
                            field.maxDate = stageDetail.end_Date;
                            field.startDate = null;
                            field.endDate = null;
                            if (!!docSetStageDetail && !!docSetStageDetail.start_Date && !!docSetStageDetail.end_Date)
                                field.value?.next([docSetStageDetail.start_Date, docSetStageDetail.end_Date]);
                            else
                                field.value?.next(new BehaviorSubject([]));
                        }
                    }
                })
                let noOfDocsRequired: FieldConfig|undefined = this.docConfig.find(x => x.name == 'noOfDocsRequired');
                if (noOfDocsRequired) {
                    let currDocSetNoOfDocs: number = 0;
                    if (this.currentEditDocSet && this.currentEditDocSet.structure_DED_Id == x.dedId) {
                        currDocSetNoOfDocs = this.currentEditDocSet.number_Of_Docs;
                    }
                    let noOfDocs: number = schDefModel.number_Of_Docs + currDocSetNoOfDocs - this.docSetList.filter(ds => ds.structure_DED_Id == x.dedId).reduce((sum, current) => sum + current.number_Of_Docs, 0);
                    if (noOfDocs <= 0) {
                        this._notificationService.showPopup("Maximum count reached!!!. Please change the structure", "Warning");
                        noOfDocs = currDocSetNoOfDocs;
                    }
                    this.docSetFormComponent.form.get('noOfDocsRequired')?.clearValidators();
                    this.docSetFormComponent.form.get('noOfDocsRequired')?.setValidators([Validators.required, Validators.max(noOfDocs), Validators.min(1), Validators.pattern("^[0-9]*$")]);
                    this.docSetFormComponent.form.get('noOfDocsRequired')?.updateValueAndValidity();
                    let maxValidator: Validator|undefined = noOfDocsRequired.validations?.find(y => y.name == 'max');
                    if (maxValidator) {
                        maxValidator.validator = Validators.max(noOfDocs);
                        maxValidator.message = "Maximum No Of Docs Required:" + noOfDocs;
                    }
                    else {
                        noOfDocsRequired.validations?.push({
                            name: "max",
                            validator: Validators.max(noOfDocs),
                            message: "Maximum No Of Docs Required:" + noOfDocs
                        });
                    }
                }
            }
        });
        this.UnsubscribeArray.push(setformbulkdoc);
    }

    clearDocsetdate() {
        if (this.docConfig && this.docConfig.length > 0) {
            let DateProperty: Array<string> = ['SD', 'DD', 'GFC'];
            DateProperty.forEach((value, ke) => {
                let field: any = this.docConfig.find(x => x.name == value);

                if (field) {
                    field.minDate = null;
                    field.maxDate = null;
                    field.startDate = null;
                    field.endDate = null;
                    field.value.next('');
                }
            });
        }
    }

    /**
     * Get Schedule Defintion - Structure details
     * @returns FieldConfig[]
     */
    getSchConfig(): FieldConfig[] {
        return [
            {
                type: 'input',
                name: 'strucutreName',
                label: 'Structure/Package Name',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "Structure/Package Name Required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern('^[a-zA-Z0-9 ]+$'),
                        message: "Special characters not allowed"
                    }
                ]
            },
            {
                type: 'input',
                name: 'structureNo',
                label: 'Structure/Package Number',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "Structure/Package Number Required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern('^[a-zA-Z0-9 ]+$'),
                        message: "Special characters not allowed"
                    }
                ]
            }];
    }

    /**
    * Get Document Set Field Config Details - Discipline & Structure details
    * @returns FieldConfig[]
    */
    getDocSetConfig(): FieldConfig[] {
        return [
            {
                type: 'select',
                name: 'Discipline',
                label: 'Discipline',
                deDescription: 'Discipline',
                module_id: Module.ScheduleDocument,
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "Please select discipline"
                    }
                ],
                value: new BehaviorSubject(null)
            },
            {
                type: 'select',
                name: 'Structure/Package Name',
                label: 'Structure/Package Name',
                deDescription: 'Structure / Package',
                module_id: Module.ScheduleDocument,
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "Structure/Package Name Required"
                    }
                ],
                value: new BehaviorSubject(null)
            },
            {
                type: 'input',
                name: 'docset',
                label: 'Document Set',
                validations: [
                    {
                        name: "required",
                        validator: Validators.required,
                        message: "Document Set Name Required"
                    },
                    {
                        name: "pattern",
                        validator: Validators.pattern('^[a-zA-Z0-9 ]+$'),
                        message: "Special characters not allowed"
                    }
                ]
            }];
    }

    loadScheduleDefintionList() {
            let getSchDeflist = this._scheDefService.getScheduleDefintionList({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IScheduleDefinitionModel[]) => {
                this.schDefList = res;
            });
            this.UnsubscribeArray.push(getSchDeflist);
    }

    loadDocSetList() {
            let docsetlist = this._scheDefService.getDocSetList({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IDocSetModel[]) => {
                this.docSetList = res;
                this.getGridColumnValue();
            });
            this.UnsubscribeArray.push(docsetlist);
    }

    /**
     * Button Toggle Event Handle
     * @param event
     */
    changeButtonToggle(event:any) {
        this.directive.skip = 0;
        this.directive.filter = null;
        this.selectedOption = event.value;
        this.enableFilter = false;
        if (this.selectedOption == 'schedule') {
            this.loadDynamicForm(true);
            this.loadScheduleDefintionList();

        }
        else {
            this.loadDynamicForm(false);
            this.loadDocSetList();
        }
    }

    saveScheduleDefintion() {
        let schDef: IScheduleDefinitionModel;
        let form: FormGroup = this.schDefFormComponent.value;
        if (!this.isSchDefEdit) {
            let schDefModel: any = this.schDefList.find(x => x.deD_Short_Description == form.get('structureNo')?.value && x.deD_Description == form.get('strucutreName')?.value);
            if (schDefModel) {
                this._notificationService.showPopup("Structure/Package name already exists", "Warning");
                return;
            }
        }
        let noDateCount = this.stageConfig.filter(x => form.get(x.rangeControlNames[1])?.value == null).length;
        if (this.stageConfig.length == noDateCount) {
            this._notificationService.showPopup("Date is mandatory for atleast one Workflow stage", "Warning");
            return;
        }
        let schDefReq: Observable<any> = this._eleDetailsService.insertUpdateElementDetails({
            deD_Description: form.get('strucutreName')?.value
            , deD_Short_Description: form.get('structureNo')?.value, dE_Id: this.structPackEleId, is_Active: true, userId: this.memberId
        }).pipe(mergeMap((res: StandardOutputModel) => {
            
            if (res.successCode == 200 || res.successCode == 205) {
                let stageDetails: IStageElementDetails[] = this.stageConfig.map(x => {
                    let stageDetail: IStageElementDetails = {
                        stage_Id: x.de_id, start_Date: form.get(x.rangeControlNames[0])?.value,
                        end_Date: form.get(x.rangeControlNames[1])?.value, stage_Description: x.label, stage_Short_Description: x.name, is_Active: true
                    };
                    return stageDetail;
                })

                schDef = {
                    project_Id: this.projectId, group_Id: this.groupId, dE_Id: this.structPackEleId, deD_Id: +res.result, number_Of_Docs: Number(form.get('noOfDocsRequired')?.value),
                    created_By: this.memberId, deD_Description: form.get('strucutreName')?.value, deD_Short_Description: form.get('structureNo')?.value, stageElementDetails: stageDetails
                }

                return this._scheDefService.insertUpdateSchDef(schDef)
            }
            else
            return new Observable<any>()

        }));
        let saveSchDef = schDefReq.subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                if (!this.isSchDefEdit) {
                    this.schDefList.push(schDef);
                    this.schDefList = [...this.schDefList];
                }
                else {
                    this.copyFields(schDef);
                }
                this._notificationService.showToast(res.successMessage, "Success");
                this.cancelScheduleDefintion();
            }
            if (res.successCode == 500) {

                this._notificationService.showToast(res.successMessage, "Error");
            }
        });
        this.UnsubscribeArray.push(saveSchDef);
    }

    copyFields(schDef: IScheduleDefinitionModel) {
        if (!!schDef) {
            let gridSchDef: IScheduleDefinitionModel = this.schDefList.filter(x => x.deD_Description == schDef.deD_Description && x.deD_Short_Description == schDef.deD_Short_Description)[0];
            gridSchDef.number_Of_Docs = schDef.number_Of_Docs;
            gridSchDef.stageElementDetails = schDef.stageElementDetails;
        }
    }

    cancelScheduleDefintion() {
        let form: FormGroup = this.schDefFormComponent.value;
        form.reset();
        form.get('strucutreName')?.enable();
        form.get('structureNo')?.enable();
        this.isSchDefEdit = false;
        this.loadDynamicForm(true);
        this.loadScheduleDefintionList();
        this._elementDetailCache.deleteElementDetails(Module.ScheduleDocument + "_Structure / Package");
    }

    cancelDocSet() {
        this.currentEditDocSet = null;
        this.loadDynamicForm(false);
        this.loadDocSetList();
    }

    editSchDef(schDef: IScheduleDefinitionModel) {
        this.isSchDefEdit = true;
        let form: FormGroup = this.schDefFormComponent.value;
        form.get('strucutreName')?.setValue(schDef.deD_Description);
        form.get('strucutreName')?.disable();
        form.get('structureNo')?.setValue(schDef.deD_Short_Description);
        form.get('structureNo')?.disable();
        form.get('noOfDocsRequired')?.setValue(schDef.number_Of_Docs);
        this.stageConfig.forEach(x => {
            let stageDetail: any = this.getStageDetail(schDef, x);
            if (stageDetail && x.rangeControlNames) {
                form.get(x.rangeControlNames[0])?.setValue(stageDetail.start_Date);
                form.get(x.rangeControlNames[1])?.setValue(stageDetail.end_Date);
            }
        })
        this._elementDetailCache.deleteElementDetails(Module.ScheduleDocument + "_Structure / Package");

    }

    editDocSet(docSet: IDocSetModel) {
        this.cancelDocSet();
        this.currentEditDocSet = docSet;
        this.isFetchDateFromDS = true;
        let disciplie: any = this.docConfig.find(x => x.name == "Discipline");
        disciplie.value.next(docSet.disc_DED_Id);
        let structure: any = this.docConfig.find(x => x.name == "Structure/Package Name");
        structure.value.next(docSet.structure_DED_Id);
        let form: FormGroup = this.docSetFormComponent.value;
        form.get('noOfDocsRequired')?.setValue(docSet.number_Of_Docs);
        form.get('docset')?.setValue(docSet.document_Set_Name);
        this.docSetStageConfig.forEach(x => {
            let stageDetail: any = this.getDocSetStageDetail(docSet, x);
            if(x.rangeControlNames){
            form.get(x.rangeControlNames[0])?.setValue(stageDetail.start_Date);
            form.get(x.rangeControlNames[1])?.setValue(stageDetail.end_Date);
            }
        })
    }

    deleteDocSet(docSet: IDocSetModel) {
        this._notificationService.showPopup('Are you sure you want to delete', 'Confirm').then(msg => {
            if (msg == 'yes') {
                let deletedocsetsch = this._scheDefService.deleteDocSet({ project_Id: this.projectId, group_Id: this.groupId, doc_Set_Id: docSet.doc_Set_Id }).subscribe((res: StandardOutputModel) => {
                    if (res.successCode == 200) {
                        this._notificationService.showToast(res.successMessage, "Success");
                        this.docSetList = [];
                        this.cancelDocSet();
                    }
                    else if (res.successCode == 205) {
                        this._notificationService.showToast(res.successMessage, "Warning");
                    }
                    else {
                        this._notificationService.showToast("Failed to delete Document Set", "Error");
                    }
                });
                this.UnsubscribeArray.push(deletedocsetsch);
            }
        });
    }

    deleteSchDef(schDef: IScheduleDefinitionModel) {
        this._notificationService.showPopup('Are you sure you want to delete', 'Confirm').then(msg => {
            if (msg == 'yes') {
                this._scheDefService.deleteSchDef({ project_Id: this.projectId, group_Id: this.groupId, struct_Id: schDef.deD_Id }).subscribe((res: StandardOutputModel) => {
                    if (res.successCode == 200) {
                        this._notificationService.showToast(res.successMessage, "Success");
                        this.schDefList = [];
                        this.cancelScheduleDefintion();
                        this._elementDetailCache.deleteElementDetails(Module.ScheduleDocument + "_Structure / Package");

                    }
                    else if (res.successCode == 205) {
                        this._notificationService.showToast(res.successMessage, "Warning");
                    }
                    else {
                        this._notificationService.showToast("Failed to delete Schedule Defintion", "Error");
                    }
                });
            }
        });
    }
    /**
     * Gets the particular stage element details
     * @param data Schedule Defintion Model Data
     * @param stage Stage Details
     * @returns Stage Element Details
     */
    getStageDetail(data: IScheduleDefinitionModel, stage: FieldConfig): IStageElementDetails|undefined {
        return data.stageElementDetails.find(x => x.stage_Id == stage.de_id);
    }

    /**
    * Gets the particular stage element details
    * @param data Document Set Model Data
    * @param stage Stage Details
    * @returns Stage Element Details
    */
    getDocSetStageDetail(data: IDocSetModel, stage: FieldConfig): IStageElementDetails|undefined {
        return data.stageDocumentSetDetails.find(x => x.stage_Id == stage.de_id);
    }

    /**
     * Gets the end date of each stage from the schedule defintion model
     * @param data Schedule Defintion Model
     * @param stage Field Config
     * @returns End date of requested stage
     */
    getDate(data: IScheduleDefinitionModel, stage: FieldConfig): string|null {
        let _obj = this.getStageDetail(data, stage);
        if (_obj)
            return this._datepipe.transform(_obj.end_Date, 'dd-MMM-yyyy');
        else
            return ''
    }

    /**
  * Gets the start & end date of each stage from the schedule defintion model
  * @param data Schedule Defintion Model
  * @param stage Field Config
  * @returns End date of requested stage
  */
    getDateRange(data: IScheduleDefinitionModel, stage: FieldConfig): string {
        let stageDetail: any = this.getStageDetail(data, stage)
        if (!!stageDetail && !!stageDetail.start_Date && !!stageDetail.end_Date)
            return this._datepipe.transform(stageDetail.start_Date, 'dd-MMM-yyyy') + " - " + this._datepipe.transform(stageDetail.end_Date, 'dd-MMM-yyyy');
        else
            return '';
    }

    /**
     * Gets the end date of each stage from the schedule defintion model
     * @param data Schedule Defintion Model
     * @param stage Field Config
     * @returns End date of requested stage
     */
    getDocSetDate(data: IDocSetModel, stage: FieldConfig): string|null {
        let _obj = this.getDocSetStageDetail(data, stage);
        if (_obj)
            return this._datepipe.transform(_obj.end_Date, 'dd-MMM-yyyy');
        else
            return '';
    }
    /**
 * Gets the start & end date of each stage from the schedule defintion model
 * @param data Schedule Defintion Model
 * @param stage Field Config
 * @returns End date of requested stage
 */
    getDocSetDateRange(data: IDocSetModel, stage: FieldConfig): string|null {
        let stageDetail: any = this.getDocSetStageDetail(data, stage)
        if (!!stageDetail && !!stageDetail.start_Date && !!stageDetail.end_Date)
            return this._datepipe.transform(stageDetail.start_Date, 'dd-MMM-yyyy') + " - " + this._datepipe.transform(stageDetail.end_Date, 'dd-MMM-yyyy');
        else
            return ''
    }

    /**
     * Gets grid column text
     * @param data 
     *
     */
    getGridColumnValue() {
        if (this.docSetList && this.docSetList.length > 0)
            this.docSetList.map(m => {
                m.disciplineDesc = m.disc_Short_Description + '-' + m.disc_Description;
                m.structureDesc = m.structure_Short_Description + '-' + m.structure_Description;
            })
    }

    saveDocSet() {
        let form: FormGroup = this.docSetFormComponent.value;
        let structure: IProjectElementDetailsOutput = form.get('Structure/Package Name')?.value;
        if (this.currentEditDocSet == null) {
            let docSetModel: any = this.docSetList.find(x => x.document_Set_Name == form.get('docset')?.value && x.structure_DED_Id == structure.dedId);
            if (docSetModel) {
                this._notificationService.showPopup("Document set name already exists", "Warning");
                // Values should not be erased
                //this.cancelDocSet();
                return;
            }
        }
        let stageDetails: IStageElementDetails[] = this.docSetStageConfig.map(x => {
            let stageDetail: IStageElementDetails = {
                stage_Id: x.de_id, start_Date: (x.rangeControlNames?form.get(x.rangeControlNames[0])?.value:null),
                end_Date: (x.rangeControlNames?form.get(x.rangeControlNames[1])?.value:null), stage_Description: x.label, stage_Short_Description: x.name, is_Active: true
            }
            return stageDetail;
        });
        let noDateCount = stageDetails.filter(x => x.end_Date == null).length;
        if (this.stageConfig.length == noDateCount) {
            this._notificationService.showPopup("Date is mandatory for atleast one Workflow stage", "Warning");
            // Values should not be erased
            //this.cancelDocSet();
            return;
        }
        let discipline: IProjectElementDetailsOutput = form.get('Discipline')?.value;
        let docSet: IDocSetModel = {
            project_Id: this.projectId, group_Id: this.groupId, document_Set_Name: form.get('docset')?.value, structure_DED_Id: structure.dedId, disc_DED_Id: discipline.dedId, number_Of_Docs: Number(form.get('noOfDocsRequired')?.value),
            disc_Short_Description: discipline.dedShortDescription, disc_Description: discipline.dedDescription, structure_Description: structure.dedDescription, structure_Short_Description: structure.dedShortDescription, created_By: this.memberId, stageDocumentSetDetails: stageDetails, is_Active: true
        }
        if (this.currentEditDocSet != null)
            docSet.doc_Set_Id = this.currentEditDocSet.doc_Set_Id;
        let updatedocset = this._scheDefService.insertUpdateDocSet(docSet).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                if (!!this.currentEditDocSet) {
                    let docSetModel: IDocSetModel = this.docSetList.filter(x => x.doc_Set_Id == docSet.doc_Set_Id)[0];
                    if (!!docSetModel) {
                        docSetModel.number_Of_Docs = docSet.number_Of_Docs;
                        docSetModel.stageDocumentSetDetails = docSet.stageDocumentSetDetails;
                        docSetModel.structure_DED_Id = docSet.structure_DED_Id;
                        docSetModel.disc_DED_Id = docSet.disc_DED_Id;
                    }
                }
                else {
                    docSet.doc_Set_Id = +res.result;
                    this.docSetList.push(docSet);
                    this.docSetList = [...this.docSetList];
                    this.getGridColumnValue();
                }
                this._notificationService.showToast(res.successMessage, "Success");
            }
            this.cancelDocSet();
            this._notificationService.showToast(res.successMessage, res.successCode == 200 ? "Success" : "Warning");
        });
        this.UnsubscribeArray.push(updatedocset);
        this.loadDocSetList();
    }

    public downloadDocSetExcelTemplate() {
        this.loaderService.isLoading.next(true);
        let inputData: IPorjectInputModel = { project_Id: this.projectId, group_Id: this.groupId }
        if (this.schDefList.length == 0 && this.docSetList.length == 0) {
            let fileName = "EngineeringSchedule_Excel_Template-" + this.projectCode + ".xlsx";
            let engschexltemplate = this._scheDefService.GetEngSchExcelTemplate(inputData).subscribe((data: any) => {
                this.loaderService.isLoading.next(false);
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(data);
                downloadLink.download = fileName;
                downloadLink.click();
                document.body.removeChild(downloadLink);
            },
                (err:any) => {
                    this.loaderService.isLoading.next(false);
                    this._notificationService.showToast("Error in downloading Template", "Warning");
                });
            this.UnsubscribeArray.push(engschexltemplate);
        }
        else {

            let fileName = "DocumentSet_Excel_Template-" + this.projectCode + ".xlsx";
            let docsetexltemp = this._scheDefService.GetDocSetExcelTemplate(inputData).subscribe((data: any) => {
                this.loaderService.isLoading.next(false);
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(data);
                downloadLink.download = fileName;
                downloadLink.click();
                document.body.removeChild(downloadLink);
            },
                (err:any) => {
                    this.loaderService.isLoading.next(false);
                    this._notificationService.showToast("Error in downloading Template", "Warning");
                });
            this.UnsubscribeArray.push(docsetexltemp);
        }
    }

    uploadDocSetClick() {
        this.excelDocSetUpload.nativeElement.click();
    }

    uploadDocSetTemplate(event: any) {
        this.loaderService.isLoading.next(true);
        if (event.target.files[0].type != this.acceptFileTypes) {
            this.loaderService.isLoading.next(false);
            this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
            this.excelDocSetUpload.nativeElement.value = '';
            return;
        }

        const formData: FormData = new FormData();
        formData.append('DocSetExcelTemplate', event.target.files[0], event.target.files[0].name);
        formData.append('ProjectId', this.projectId.toString());
        formData.append('GroupId', this.groupId.toString());
        formData.append('MemberId', this.memberId.toString());
        if (this.schDefList.length == 0 && this.docSetList.length == 0) {
            let uploadEngSchExlTemp = this._scheDefService.UploadEngSchExcelTemplate(formData).subscribe((res: IScheduleDefUploadStatusModel[]) => {
                this.loaderService.isLoading.next(false);
                if (res.length > 0) {
                    let dialogRef = this.dialog.open(ScheduleDefinitionExcelUploadComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: { schDefres: res, module: "Engineering Schedule Definition" },
                    });
                    dialogRef.afterClosed().subscribe((res: any) => {
                        this.docSetList = [];
                        this.loadDocSetList();
                    });
                }
                else {
                    this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
                }
                this.excelDocSetUpload.nativeElement.value = '';
            }, (err:any) => {
                this.loaderService.isLoading.next(false);
                this.excelDocSetUpload.nativeElement.value = '';
                this._notificationService.showToast("Error in upload Template", "Warning");
            });
            this.UnsubscribeArray.push(uploadEngSchExlTemp);
        }
        else {

            let uploadDocSetExlTemp = this._scheDefService.UploadDocSetExcelTemplate(formData).subscribe((res: IScheduleDefUploadStatusModel[]) => {
                this.loaderService.isLoading.next(false);
                if (res.length > 0) {
                    let dialogRef = this.dialog.open(ScheduleDefinitionExcelUploadComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: { schDefres: res, module: "Document Set" },
                    });
                    dialogRef.afterClosed().subscribe((res: any) => {
                        this.docSetList = [];
                        this.loadDocSetList();
                        this.schDefList = [];
                        this.loadScheduleDefintionList();
                    });
                }
                else {
                    this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
                }
                this.excelDocSetUpload.nativeElement.value = '';
            }, (err:any) => {
                this.loaderService.isLoading.next(false);
                this.excelDocSetUpload.nativeElement.value = '';
                this._notificationService.showToast("Error in upload Template", "Warning");
            });
            this.UnsubscribeArray.push(uploadDocSetExlTemp);
        }
    }

    public downloadSchDefExcelTemplate() {
        this.loaderService.isLoading.next(true);
        let inputData: IPorjectInputModel = { project_Id: this.projectId, group_Id: this.groupId }
        if (this.schDefList.length == 0 && this.docSetList.length == 0) {
            let fileName = "EngineeringSchedule_Excel_Template-" + this.projectCode + ".xlsx";
            let getengSchexltemp = this._scheDefService.GetEngSchExcelTemplate(inputData).subscribe((data: any) => {
                this.loaderService.isLoading.next(false);
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(data);
                downloadLink.download = fileName;
                downloadLink.click();
                document.body.removeChild(downloadLink);
            },
                (err:any) => {
                    this.loaderService.isLoading.next(false);
                    this._notificationService.showToast("Error in downloading Template", "Warning");
                });
            this.UnsubscribeArray.push(getengSchexltemp);
        }
        else {
            let fileName = "ScheduleDefinition_Excel_Template-" + this.projectCode + ".xlsx";
            let getschdefexltemp = this._scheDefService.GetSchDefExcelTemplate(inputData).subscribe((data: any) => {
                this.loaderService.isLoading.next(false);
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(data);
                downloadLink.download = fileName;
                downloadLink.click();
                document.body.removeChild(downloadLink);
            },
                (err:any) => {
                    this.loaderService.isLoading.next(false);
                    this._notificationService.showToast("Error in downloading Template", "Warning");
                });
            this.UnsubscribeArray.push(getschdefexltemp);
        }
    }

    uploadSchDefClick() {
        this.excelSchDefUpload.nativeElement.click();
    }

    uploadSchDefTemplate(event: any) {
        this.loaderService.isLoading.next(true);
        if (event.target.files[0].type != this.acceptFileTypes) {
            this.loaderService.isLoading.next(false);
            this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
            this.excelSchDefUpload.nativeElement.value = '';
            return;
        }

        const formData: FormData = new FormData();
        formData.append('SchDefExcelTemplate', event.target.files[0], event.target.files[0].name);
        formData.append('ProjectId', this.projectId.toString());
        formData.append('GroupId', this.groupId.toString());
        formData.append('MemberId', this.memberId.toString());
        if (this.schDefList.length == 0 && this.docSetList.length == 0) {
            let uploadengschexltemp = this._scheDefService.UploadEngSchExcelTemplate(formData).subscribe((res: IScheduleDefUploadStatusModel[]) => {
                this.loaderService.isLoading.next(false);
                if (res.length > 0) {
                    let dialogRef = this.dialog.open(ScheduleDefinitionExcelUploadComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: { schDefres: res, module: "Engineering Schedule Definition" },
                    });
                    dialogRef.afterClosed().subscribe((res: any) => {
                        this.docSetList = [];
                        this.loadDocSetList();
                        this.schDefList = [];
                        this.loadScheduleDefintionList();
                    });
                }
                else {
                    this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
                }
                this.excelDocSetUpload.nativeElement.value = '';
            }, (err:any) => {
                this.loaderService.isLoading.next(false);
                this.excelDocSetUpload.nativeElement.value = '';
                this._notificationService.showToast("Error in upload Template", "Warning");
            });
            this.UnsubscribeArray.push(uploadengschexltemp);
        }
        else {
            let uploadSchdefexlTemp = this._scheDefService.UploadSchDefEExcelTemplate(formData).subscribe((res: IScheduleDefUploadStatusModel[]) => {
                this.loaderService.isLoading.next(false);
                if (res.length > 0) {
                    let dialogRef = this.dialog.open(ScheduleDefinitionExcelUploadComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: { schDefres: res, module: "Schedule Definition" },
                    });
                    dialogRef.afterClosed().subscribe((res: any) => {
                        this.schDefList = [];
                        this.loadScheduleDefintionList();
                    });
                }
                else {
                    this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
                }
                this.excelSchDefUpload.nativeElement.value = '';
            }, (err:any) => {
                this.loaderService.isLoading.next(false);
                this.excelSchDefUpload.nativeElement.value = '';
                this._notificationService.showToast("Error in upload Template", "Warning");
            });
            this.UnsubscribeArray.push(uploadSchdefexlTemp);
        }
    }
    toggleFilter() {
        this.enableFilter = !this.enableFilter;
    }

    reviseDocSet(docSet: IDocSetModel) {
        let schDefModel: any = this.schDefList.find(y => y.deD_Id == docSet.structure_DED_Id);
        let currDocSetNoOfDocs: number = docSet.number_Of_Docs;
        let noOfDocs: any = schDefModel.number_Of_Docs + currDocSetNoOfDocs - this.docSetList.filter(ds => ds.structure_DED_Id == docSet.structure_DED_Id).reduce((sum, current) => sum + current.number_Of_Docs, 0);
        const dialogRef = this._dialog.open(DocSetReviseComponent, {
            panelClass: 'mat-dialog-primary',
            data: { docSet: docSet, schDef: schDefModel, noOfDocs: noOfDocs },
            autoFocus: false,
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((x:any) => {
            this.docSetList = [];
            this.loadDocSetList();
        })
    }
    enableMemberRoleFeatures() {
        let projectMemFeature = this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {
            this.isAllowEdit = res.some(data => data.feature_Desc == 'Document Set Edit');
        });
        this.UnsubscribeArray.push(projectMemFeature);
    }

    ngOnDestroy(): void {
        this.UnsubscribeArray.forEach(x => x.unsubscribe());
    }
}
